"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function HalfDiamond(props) {
  return _react2["default"].createElement(
    "svg",
    { className: props.className, width: props.size, height: props.size, viewBox: "0 0 64 64" },
    _react2["default"].createElement(
      "defs",
      null,
      _react2["default"].createElement(
        "filter",
        { id: "a", filterUnits: "userSpaceOnUse", x: ".61", y: "4.728", width: "61.982", height: "54.188" },
        _react2["default"].createElement("feColorMatrix", { values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0" })
      )
    ),
    _react2["default"].createElement(
      "mask",
      { maskUnits: "userSpaceOnUse", x: ".61", y: "4.728", width: "61.982", height: "54.188", id: "b" },
      _react2["default"].createElement("path", { fill: "#FFF", d: "M63 5H30.814v53.78H63z", filter: "url(#a)" })
    ),
    _react2["default"].createElement(
      "g",
      { transform: "translate(.89 .55)", mask: "url(#b)" },
      _react2["default"].createElement("path", { fill: "#F7BC1A", d: "M.022 18.83l30.27 37.016.07-.092L15.35 18.83z" }),
      _react2["default"].createElement("path", { fill: "#FACB25", d: "M-.28 18.468l.302.362H15.35l6.84-13.653h-9.56z" }),
      _react2["default"].createElement("path", { fill: "#DAE2ED", d: "M61.235 19.83h-15.89l-7.58-15.653h11.37l12.385 14.93M46.6 17.83h11.323L48.24 6.177h-7.284L46.6 17.83z" }),
      _react2["default"].createElement("path", { fill: "#DAE2ED", d: "M61.702 19.41l-30.816 38.4-1.442-2.193L45.31 17.83h15.113m-13.788 2L33.943 49.854 58.76 19.83H46.636z" }),
      _react2["default"].createElement("path", { fill: "none", stroke: "#DAE2ED", strokeWidth: "2", d: "M15.35 18.83l15.013 36.924 15.61-36.924zm0 0h30.62L39.36 5.177H22.192z" })
    ),
    _react2["default"].createElement(
      "defs",
      null,
      _react2["default"].createElement(
        "filter",
        { id: "c", filterUnits: "userSpaceOnUse", x: "1", y: "4.938", width: "60.487", height: "53.987" },
        _react2["default"].createElement("feColorMatrix", { values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0" })
      )
    ),
    _react2["default"].createElement(
      "mask",
      { maskUnits: "userSpaceOnUse", x: "1", y: "4.938", width: "60.487", height: "53.987", id: "d" },
      _react2["default"].createElement("path", { fill: "#FFF", d: "M-.226 4.75H31.96v56.818H-.226z", filter: "url(#c)" })
    ),
    _react2["default"].createElement(
      "g",
      { transform: "translate(.89)", mask: "url(#d)" },
      _react2["default"].createElement("path", { fill: "#F7BC1A", d: "M60.598 19.135l-29.713 39.03-.167.333-.333-.25L45.27 19.134z" }),
      _react2["default"].createElement("path", { fill: "#FF8A3D", d: "M21.636 4.938l-6.612 14.574H.11L12.307 4.938z" }),
      _react2["default"].createElement("path", { fill: "#FF6A00", d: "M30.632 58.926L.11 19.512h14.914z" }),
      _react2["default"].createElement("path", { fill: "#FF8A3D", d: "M45.646 19.512L30.632 58.926 15.024 19.512z" }),
      _react2["default"].createElement("path", { fill: "#FFAC74", d: "M45.646 19.512H15.024l6.612-14.574h17.167z" })
    )
  );
}

exports["default"] = HalfDiamond;
module.exports = exports["default"];